import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pgs-custom-checkbox-cell',
    template: `<div class="custom-control custom-checkbox">
                 <input pgsInputFilter type="checkbox" class="custom-control-input" id="{{id}}" [(ngModel)]="rowData[key]">
                 <label class="custom-control-label" for="{{id}}"></label>
               </div>`,
    styles: [`label::after, label::before { top: 0; bottom: 0; margin: auto; right: 0; }`]
})

export class CustomCheckboxCellComponent implements OnInit {

    key: string;
    id: number;

    constructor() { }

    @Input() value: any;

    @Input() rowData: any;

    ngOnInit(): void {
        this.id = Date.now();
    }
}
